import { Component, EventEmitter, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-application-header',
  imports: [TranslateModule],
  templateUrl: './application-header.html',
  styleUrl: './application-header.scss',
})
export class ApplicationHeader {
  @Output() readonly createRequested = new EventEmitter<void>();

  requestCreate(): void {
    this.createRequested.emit();
  }
}
